import Icons, { IconsProps } from '../Icons';

export default function (props: IconsProps) {
  return (
    <Icons viewBox="0 0 32 32">
      <path
        d="M8.66667 18.6167H18V17.2834H8.66667V18.6167ZM8.66667 14.6167H23.3333V13.2834H8.66667V14.6167ZM8.66667 10.6167H23.3333V9.28337H8.66667V10.6167ZM4 27.3834V6.78337C4 6.16114 4.20578 5.64425 4.61733 5.2327C5.028 4.82203 5.54444 4.6167 6.16667 4.6167H25.8333C26.4556 4.6167 26.9724 4.82203 27.384 5.2327C27.7947 5.64425 28 6.16114 28 6.78337V21.1167C28 21.7389 27.7947 22.2558 27.384 22.6674C26.9724 23.078 26.4556 23.2834 25.8333 23.2834H8.1L4 27.3834ZM5.33333 24.15L7.53333 21.95H25.8333C26.0778 21.95 26.2778 21.8723 26.4333 21.7167C26.5889 21.5611 26.6667 21.3611 26.6667 21.1167V6.78337C26.6667 6.53892 26.5889 6.33892 26.4333 6.18337C26.2778 6.02781 26.0778 5.95003 25.8333 5.95003H6.16667C5.92222 5.95003 5.72222 6.02781 5.56667 6.18337C5.41111 6.33892 5.33333 6.53892 5.33333 6.78337V24.15ZM5.33333 6.78337V5.95003V24.15V6.78337Z"
        fill={props.fill || '#F6F3E7'}
      />
    </Icons>
  );
}
